<template>
  <div>
    <vs-tabs class="bg_filled_tab_holder" v-model="tabIndex">
      <vs-tab label="Today">
        <div
          class="
            table-responsive
            cstm_vuexy_table
            horizontal_scrollbar
            vertical_scrollbar
          "
          style="max-height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Teacher Name</th>
                <th>Course Name</th>
                <th>Date</th>
                <th style="width: 220px">Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in attendance_list" :key="index">
                <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
                <td>{{ item.course ? item.course.name : "" }}</td>
                <td>{{ item.schedule_date }}</td>
                <td>
                  <div class="flex flex-wrap items-center">
                    <ul class="inline-flex items-center attendance_ul">
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          @change="markTeacher(item)"
                          :vs-value="true"
                          >Present</vs-radio
                        >
                      </li>
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          @change="markTeacher(item)"
                          :vs-value="false"
                          >Absent</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
      <vs-tab label="This Week">
        <div
          class="
            table-responsive
            cstm_vuexy_table
            horizontal_scrollbar
            vertical_scrollbar
          "
          style="max-height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Teacher Name</th>
                <th>Course Name</th>
                <th>Date</th>
                <th style="width: 220px">Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in attendance_list" :key="index">
                <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
                <td>{{ item.course ? item.course.name : "" }}</td>
                <td>{{ item.schedule_date }}</td>
                <td>
                  <div class="flex flex-wrap items-center">
                    <ul class="inline-flex items-center attendance_ul">
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          @change="markTeacher(item)"
                          :vs-value="true"
                          >Present</vs-radio
                        >
                      </li>
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          @change="markTeacher(item)"
                          :vs-value="false"
                          >Absent</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
      <vs-tab label="This Month">
        <div
          class="
            table-responsive
            cstm_vuexy_table
            horizontal_scrollbar
            vertical_scrollbar
          "
          style="max-height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Teacher Name</th>
                <th>Course Name</th>
                <th>Date</th>
                <th style="width: 220px">Attendance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in attendance_list" :key="index">
                <td>{{ item.user.first_name }} {{ item.user.last_name }}</td>
                <td>{{ item.course ? item.course.name : "" }}</td>
                <td>{{ item.schedule_date }}</td>
                <td>
                  <div class="flex flex-wrap items-center">
                    <ul class="inline-flex items-center attendance_ul">
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          @change="markTeacher(item)"
                          :vs-value="true"
                          >Present</vs-radio
                        >
                      </li>
                      <li class="inline-flex items-center mr-4 p-0">
                        <vs-radio
                          v-model="item.attendance"
                          :vs-name="index"
                          @change="markTeacher(item)"
                          :vs-value="false"
                          >Absent</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import { fetchTeacheAttendance } from '@/api/dashboard.js'
import { markAttendenceTeacher } from '@/api/calenderAction.js'
export default {
  data () {
    return {
      attendance: 'Present',
      openDelay: false,
      tabIndex: 0,
      attendance_list: [],
      customer_id: localStorage.getItem('customer_id'),
      attendance_meta: {
        current_page: 1,
        has_next: false,
        limit: 5,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  watch: {
    tabIndex () {
      this.fetchAttendance()
    }
  },
  mounted () {
    this.fetchAttendance()
  },
  methods: {
    async markTeacher (attendancedetails) {
      console.log(attendancedetails)
      const payload = {
        course_id: attendancedetails.course_id,
        schedule_id: attendancedetails.id,
        unique_id: attendancedetails.unique_id,
        attendance_date: this.$moment(attendancedetails.schedule_date).format(
          'YYYY-MM-DD'
        ),
        teachers: [
          {
            attendance: attendancedetails.attendance,
            teacher_id: attendancedetails.user.id
          }
        ]
      }

      await markAttendenceTeacher(this.customer_id, payload)
      this.showSuccessMessage(
        'Success',
        'Teacher marked Successfully',
        'success'
      )
    },
    async fetchAttendance () {
      this.$vs.loading()
      const payload = {
        dateRange: this.tabIndex + 1,
        limit: 5
      }
      this.attendance_meta.current_page = 1
      const { data } = await fetchTeacheAttendance(
        localStorage.getItem('customer_id'),
        payload,
        this.attendance_meta
      )
      this.attendance_list = data.data.teachers
      this.attendance_meta = data.data.meta
      this.$vs.loading.close()
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.loadMoreAttendance()
      }
    },
    async loadMoreAttendance () {
      this.attendance_meta.current_page += 1
      const payload = {
        dateRange: this.tabIndex + 1,
        limit: 5
      }
      const { data } = await fetchTeacheAttendance(
        localStorage.getItem('customer_id'),
        payload,
        this.attendance_meta
      )
      this.attendance_list.push(...data.data.teachers)
      this.attendance_meta = data.data.meta
    }
  }
}
</script>